import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthContextProvider } from "./contexts/AuthContext";
import "./index.css";
import { SidebarLayoutProvider } from "./contexts/SidebarLayoutContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <AuthContextProvider>
    <SidebarLayoutProvider>
      <App />
    </SidebarLayoutProvider>
  </AuthContextProvider>
  // </React.StrictMode>
);
